import { useQuery } from '@tanstack/react-query';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
export const useDropMedia = (mnemonicId) => {
    var _a;
    const { fetcher } = useDareDropApi();
    // This is dirty workaround. Please find a method of net sending this request when component unmounts
    const isDropPage = (_a = global.window) === null || _a === void 0 ? void 0 : _a.location.pathname.startsWith('/e/');
    return useQuery({
        queryKey: [dropEndpointIds.GET_DROP_MEDIA, mnemonicId],
        queryFn: () => {
            if (!isDropPage) {
                return [];
            }
            return fetcher({
                endpointId: dropEndpointIds.GET_DROP_MEDIA,
                payload: {
                    dropMnemonicId: mnemonicId,
                },
            });
        },
    });
};
